export default __webpack_public_path__ + "static/media/ep_17.562ebd80.png";